import {useCallback, useMemo} from 'react';

import {TextArea} from '#component/base';
import {QuestionControls, QuestionText} from '#component/partial/Wizard/component';
import {useSurveyVar} from '#component/partial/Wizard/useSurveyVar';
import {sprinkles} from '#style/sprinkles';

import {LongTextQuestionProps} from './LongTextQuestion.types';

export const LongTextQuestion = ({onBack, onNext, question, surveyId}: LongTextQuestionProps) => {
  const {maxLength, minLength, defaultValue, placeholder} = question.longTextConfiguration || {};
  const {currentValue, onChange} = useSurveyVar({surveyId, question});
  const trimmedValue = (currentValue as string)?.trim();

  const isValid = useMemo(() => {
    // Set reasonable defaults for the min and max lengths
    const min = minLength || 1;
    const max = maxLength || 99999;

    // Make sure the value has a length and is between the min and max
    return trimmedValue.length > 0 && trimmedValue.length >= min && trimmedValue.length <= max;
  }, [maxLength, minLength, trimmedValue]);

  const handleSubmit = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault();

      if (isValid) {
        onNext();
      }
    },
    [isValid, onNext],
  );

  return (
    <form
      className={sprinkles({flex: 'flex', dir: 'col', gap: [40, 64, 80]})}
      onSubmit={handleSubmit}>
      <QuestionText text={question.text} description={question.description} />

      <TextArea
        autoFocus
        defaultValue={defaultValue || undefined}
        maxLength={maxLength || undefined}
        minLength={minLength || undefined}
        onChange={onChange}
        placeholder={placeholder || undefined}
        value={currentValue}
      />

      <QuestionControls disabledNext={!isValid} onBack={onBack} />
    </form>
  );
};
